import * as React from "react";
import {
  EnrichmentSource,
  enrichmentShortLabel,
  enrichmentSourceLabel,
} from "./types";
import styles from "./EnrichmentBadge.module.css";

const BADGE_CLASS: Record<"broker" | "nearmap" | "cape", string> = {
  broker: styles.broker,
  nearmap: styles.nearmap,
  cape: styles.cape,
};

// The vendor data a run modeled with, as a pill. ``title`` replaces the
// default tooltip (the long-form label).
export const EnrichmentBadge: React.FC<{
  source: EnrichmentSource;
  title?: string;
}> = ({ source, title }) => (
  <span
    className={`${styles.badge} ${BADGE_CLASS[source ?? "broker"]}`}
    title={title ?? enrichmentSourceLabel(source)}
  >
    {enrichmentShortLabel(source)}
  </span>
);
